import { useMemo } from 'react';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { ProjectDto } from '@/core';

export type FormValueType = {
  sourceName: string;
  name: string;
};

export const useSchemaColumn = (projectData: ProjectDto, initialValue: FormValueType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const existingSourceColumns = projectData.columns
    .map((column) => column.sourceName.toLocaleLowerCase())
    .filter((column) => column !== initialValue?.sourceName?.toLocaleLowerCase());
  const existingColumns = projectData.columns
    .map((column) => column.name?.toLocaleLowerCase())
    .filter((column) => column !== initialValue?.name?.toLocaleLowerCase());

  return useMemo(
    () =>
      Yup.object().shape({
        name: Yup.string()
          .nullable()
          .required()
          .lowercase()
          .notOneOf(existingColumns, t('addColumns.existing.name')),
        sourceName: Yup.string()
          .nullable()
          .required()
          .lowercase()
          .notOneOf(existingSourceColumns, t('addColumns.existing.sourceName')),
      }),
    [t, existingColumns, existingSourceColumns],
  );
};
